import React, { useState } from 'react';
import { Magazine } from '@shared/types/magazine';
import defaultCover from '@shared/assets/images/default-cover.png';

interface MagazineCardProps {
    magazine: Magazine,
    onQuickView?: (magazine: Magazine) => void,
    onClick?: (magazine: Magazine) => void
}

const MagazineCard = ({ magazine, onQuickView, onClick }: MagazineCardProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <article
            className='cursor-pointer flex flex-col gap-[8px] animate-in fade-in zoom-in-90 duration-300'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => onClick?.(magazine)}
        >
            {/* Image container */}
            <div className='relative aspect-[3/4] overflow-hidden'>
                <img
                    src={magazine.linkImg}
                    alt={magazine.title}
                    className='w-full h-full object-fill'
                    loading='lazy'
                    onError={(e) => {
                        e.currentTarget.src = defaultCover;
                    }}
                />

                {/* Quick view overlay */}
                <div
                    className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
                >
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onQuickView?.(magazine);
                        }}
                        className='hidden md:block bg-[image:linear-gradient(to_right,white_50%,var(--primary)_50%)] bg-[length:200%_100%] bg-right hover:bg-left border border-primary hover:border-black text-white hover:text-black py-2.5 px-6 rounded-[10px] font-semibold text-sm transition-all duration-300'
                    >
                        クイックビュー
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className='flex flex-col gap-1'>
                <h3 className='font-bold text-sm leading-[26px] line-clamp-2'>
                    {magazine.title}
                </h3>
            </div>
        </article>
    );
};

export default MagazineCard;
